"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndentations = void 0;

var getIndentations = function getIndentations(_ref) {
  var type = _ref.type,
      _ref$indentObj = _ref.indentObj,
      indentObj = _ref$indentObj === void 0 ? {} : _ref$indentObj;
  return Object.entries(indentObj).reduce(function (indents, indent) {
    return "".concat(indents, " ").concat(type, "-").concat(indent[0], ": var(--i-").concat(indent[1], ");");
  }, '');
};

exports.getIndentations = getIndentations;